import { useSelector } from 'react-redux';
import { UserState } from '@/reducers/user';

export default function useUser() {
  const user = useSelector((state: { user: UserState }) => state.user.user);

  return user;
}
